<template>
  <b-col class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="3">
                  <i class="fa fa-bars"></i> {{$t('str.forum-subcategories')}}
                </b-col>
                <b-col sm="9"></b-col>
              </b-row>
            </div>

            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="3">{{$t('str.keyword')}}</b-col>
                    <b-col sm="2">{{$t('str.category')}}</b-col>
                    <b-col sm="2">{{$t('str.country')}}</b-col>
                    <template v-if="$auth.session.get('role') == 'admin'">
                      <b-col sm="2">{{$t('str.office')}}</b-col>
                      <b-col sm="3"></b-col>
                    </template>
                    <template v-else>
                      <b-col sm="5"></b-col>
                    </template>
                  </b-row>
                  <b-row>
                    <b-col sm="3">
                      <b-form-input id="keyword" class="form-control" type="text" name="keyword"
                        :placeholder="$t('str.search')" v-model="keyword"></b-form-input>
                    </b-col>
                    <b-col sm="2">
                      <b-form-select id="category" name="category" :plain="true" v-model="category" style="height:100%;">
                        <option value="">All</option>
                        <option v-for="(c, i) in categorySelect" :value="c.value" :key="i">{{c.text}}</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="2">
                      <b-form-select id="country" name="country" :plain="true" v-model="country" style="height:100%;">
                        <option value="">All</option>
                        <option v-for="(c, i) in countrySelect" :value="c.value" :key="i">{{c.text}}</option>
                      </b-form-select>
                    </b-col>
                    <template v-if="$auth.session.get('role') == 'admin'">
                      <b-col sm="2">
                        <b-form-select id="office" name="office" :plain="true" v-model="office" style="height:100%;">
                          <option value="">All</option>
                          <option v-for="(c, i) in officeSelect" :value="c.value" :key="i">{{c.text}}</option>
                        </b-form-select>
                      </b-col>
                      <b-col sm="3">
                        <buttons button-type="search" @click="getList()" />&nbsp;
                        <buttons button-type="reset_filter" @click="resetFilter()" />
                      </b-col>
                    </template>
                    <template v-else>
                      <b-col sm="5">
                        <buttons button-type="search" @click="getList()" />&nbsp;
                        <buttons button-type="reset_filter" @click="resetFilter()" />
                      </b-col>
                    </template>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="9"></b-col>
                    <b-col sm="3">
                      <router-link to="/office/forum/subcategory/manage/0" class="btn-setting">
                        <buttons button-type="add_new" />
                      </router-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>

          <p :class="{'text-center': true, 'd-none': items.length}" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{'d-none': !items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template v-if="data.item.deleted_at" slot="deleted_at" slot-scope="data">
              {{ data.item.deleted_at | moment('from', 'now') }}
            </template>
            <template slot="action" slot-scope="data">
              <router-link :to="'/office/forum/subcategory/manage/' + data.item.id">
                <buttons button-type="edit" />
              </router-link>
              &nbsp;
              <buttons v-if="!data.item.deleted_at" button-type="delete" @click="confirmDelete(data.item.id)" />
            </template>
          </b-table>
          <nav :class="{'d-none': !items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged"
              prev-text="Prev" next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <confirm-modal :item="confirmDeleteId" @confirm="deleteData" @cancel="cancelDelete"></confirm-modal>
  </b-col>
</template>

<script>
import axios from 'axios'

import Pagination from '@/views/component/Pagination'
import ConfirmModal from '@/views/component/ConfirmModal'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'ForumSubcategory',
  components: {
    'paging': Pagination,
    'confirm-modal': ConfirmModal,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', sortable: true },
        { key: 'category_name', label: 'Category', sortable: true },
        { key: 'country_name', label: 'Country', sortable: true },
        { key: 'office_name', label: 'Office', sortable: true },
        { key: 'deleted_at', label: 'Deleted', sortable: true},
        { key: 'action' }
      ],
      keyword: '',
      currentPage: 1,
      totalPage: 0,
      confirmModal: false,
      confirmDeleteId: '',
      category: '',
      country: '',
      office: '',
      categorySelect: [],
      countrySelect: [],
      officeSelect: [],
    }
  },
  methods: {
    async getCategorySelect() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Forum/Category`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.categorySelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getCountrySelect() {
      this.$auth.checkSession()
      try {
        let url = `${this.$helper.envi.VUE_APP_API_URL}/Country`
        if (this.$auth.session.get('role') == 'officer') {
          url = `${url}/ByUserOfficeSelect`
        }

        let getData = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.countrySelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getOfficeSelect() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Office`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.officeSelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },

    async getList(page) {
      this.$auth.checkSession()
      let trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.category != '') trail = `${trail}&category=${this.category}`
      if (this.country != '') trail = `${trail}&country=${this.country}`
      if (this.office != '') trail = `${trail}&office=${this.office}`

      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Forum/Subcategory${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data

        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e.response)
      }
    },

    async deleteData(id) {
      this.$auth.checkSession()
      try {
        let result = await axios.delete(`${this.$helper.envi.VUE_APP_API_URL}/Forum/Subcategory/${id}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
        this.confirmModal = false
      } catch (e) {
        console.log(e.response)
      }
    },

    resetFilter() {
      this.keyword = ''
      this.category = ''
      this.country = ''
      this.office = ''
      this.getCategorySelect()
      this.getCountrySelect()
      this.getOfficeSelect()
      this.getList()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getList(pageNum)
    },
    confirmDelete(id) {
      this.$auth.checkSession()
      this.confirmModal = true
      this.confirmDeleteId = id
    },
    cancelDelete() {
      this.$auth.checkSession()
      this.confirmModal = false
    }
  },
  created() {
    this.getCategorySelect()
    this.getCountrySelect()
    this.getOfficeSelect()
    this.getList()
  }
}
</script>